import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrKM: CultureInfo = {
  name: 'fr-KM',
  displayName: 'français (Comores)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-KM',
  parent: CultureInfoFr
};
